import { DefaultValue } from '@billy/design-system'
import styled from '@emotion/styled'

export const AdressSelectorContainer = styled.div`
  div,
  input {
    border-radius: 0;
  }

  > div:first-of-type {
    margin-bottom: 0;

    div {
      border-bottom: none;
      border-top-left-radius: ${DefaultValue.BorderRadius};
      border-top-right-radius: ${DefaultValue.BorderRadius};
    }
  }

  > div > * {
    margin-bottom: 0;

    &:first-of-type {
      flex: 1;

      div {
        border-bottom-left-radius: ${DefaultValue.BorderRadius};
      }
    }

    &:last-of-type {
      flex: 2;

      div {
        border-left: none;
        border-bottom-right-radius: ${DefaultValue.BorderRadius};
      }
    }
  }
`
